module.exports = __webpack_public_path__ + "static/img/ps_gift.5ea7fc5a.png";